import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useToast
} from '@homebotapp/hb-react-component-catalog'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { deleteTeamMembership } from '../../../../store/slices/homebotNetwork/clientTeamMemberships'
import { defineMessages, useIntl } from 'react-intl'
import { AppDispatch } from '../../../../store'
interface ConfirmRemovePreferredAgentModalProps {
  isOpen: boolean
  onClose: () => void
  membershipId?: string
  clientId: string
  onSuccess?: () => void
}

export const MSG = defineMessages({
  confirmPreferredAgentMessage: {
    id: 'confirmPreferredAgent.confirmMessage',
    defaultMessage:
      'Are you sure you want to remove this agent from your Homebot team? They will no longer have access to your information or be able to communicate with you through Homebot.'
  },
  heading: {
    id: 'confirmPreferredAgent.heading',
    defaultMessage: 'Remove agent from your Homebot team'
  },
  cancel: {
    id: 'cancelPreferredAgent.cancel',
    defaultMessage: 'Cancel'
  },
  remove: {
    id: 'cancelPreferredAgent.remove',
    defaultMessage: 'Remove agent'
  }
})

export const ConfirmRemovePreferredAgentModal = ({
  isOpen,
  onClose,
  membershipId,
  clientId,
  onSuccess
}: ConfirmRemovePreferredAgentModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const toast = useToast()
  const dispatch = useDispatch<AppDispatch>()
  const intl = useIntl()

  const handleDelete = async () => {
    if (!membershipId || !clientId) return

    setIsDeleting(true)
    try {
      const action = await dispatch(
        deleteTeamMembership({
          clientId,
          membershipId
        })
      )
      if (action.meta.requestStatus === 'fulfilled') {
        toast({
          title: 'Success',
          description: 'Agent removed successfully',
          status: 'success'
        })

        onClose()
        setTimeout(() => {
          if (onSuccess) {
            onSuccess()
          }
        }, 100)
      } else if (action.meta.requestStatus === 'rejected') {
        throw new Error(action.payload as string)
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to remove agent. Please try again.',
        status: 'error'
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size='lg'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text size='lg' fontWeight='semibold' color='neutral.900'>
              {intl.formatMessage(MSG.heading)}
            </Text>
          </ModalHeader>

          <ModalCloseButton />

          <ModalBody pb={6}>
            <Text color='neutral.700' size='sm'>
              {intl.formatMessage(MSG.confirmPreferredAgentMessage)}
            </Text>
          </ModalBody>

          <ModalFooter>
            <Stack direction='row' gap={2}>
              <Button
                variant='ghost'
                onClick={onClose}
                tracking={{
                  guid: 'fvKXGKUN9HgMhBwSgnhGhg',
                  ui_context: 'Cancel remove agent modal',
                  descriptor: 'Cancel remove agent from team'
                }}
              >
                {intl.formatMessage(MSG.cancel)}
              </Button>
              <Button
                colorScheme='danger'
                isLoading={isDeleting}
                onClick={handleDelete}
                tracking={{
                  guid: 'g9UoAWqBsbqEwfMQU67vHM',
                  ui_context: 'Remove agent modal',
                  descriptor: 'Remove agent from team'
                }}
              >
                {intl.formatMessage(MSG.remove)}
              </Button>
            </Stack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
